<cms-disruptions *ngIf="enableGlobalBanner" [disruptions]="collection$ | async" [isGlobalBanner]="true" />
